module.exports = __webpack_public_path__ + "img/abt-bg.a41952b9.jpg";